import { render, staticRenderFns } from "./profile-information.vue?vue&type=template&id=643a6dfe&"
import script from "./profile-information.vue?vue&type=script&lang=js&"
export * from "./profile-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports